import React, { useState, useRef, useEffect } from 'react';
import { DownOutlined } from '@ant-design/icons';
import './SimpleDropdown.css';

interface DropdownOption {
  key: string;
  label: string;
}

interface SimpleDropdownProps {
  options: DropdownOption[];
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  size?: 'large' | 'middle' | 'small';
}

const SimpleDropdown: React.FC<SimpleDropdownProps> = ({
  options,
  value,
  onChange,
  placeholder = "Select an option",
  disabled = false,
  size = 'large'
}) => {
  const [visible, setVisible] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setVisible(false);
      }
    };

    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);

  const handleToggle = () => {
    if (!disabled) {
      setVisible(!visible);
    }
  };

  const handleSelect = (option: DropdownOption) => {
    console.log('Simple dropdown selecting:', option);
    onChange(option.key);
    setVisible(false);
  };

  const selectedOption = options.find(option => option.key === value);

  return (
    <div className="simple-dropdown" ref={dropdownRef}>
      <div
        className={`simple-dropdown-button ${disabled ? 'disabled' : ''} size-${size}`}
        onClick={handleToggle}
      >
        <span>{selectedOption ? selectedOption.label : placeholder}</span>
        <DownOutlined />
      </div>

      {visible && (
        <div className="simple-dropdown-menu">
          {options.map(option => (
            <div
              key={option.key}
              className={`simple-dropdown-item ${value === option.key ? 'selected' : ''}`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SimpleDropdown; 